/**
 * Shared constants for public menu components.
 */

export const DEFAULT_BANNERS = [
  "https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=1200&h=400&fit=crop",
  "https://images.unsplash.com/photo-1553621042-f6e147245754?w=1200&h=400&fit=crop",
  "https://images.unsplash.com/photo-1617196034183-421b4917c92d?w=1200&h=400&fit=crop",
];

export const ALLERGEN_INFO = {
  gluten: { name: "Gluten", icon: "\uD83C\uDF3E", color: "#D97706" },
  crustaceans: { name: "Crustaceos", icon: "\uD83E\uDD90", color: "#DC2626" },
  eggs: { name: "Ovos", icon: "\uD83E\uDD5A", color: "#F59E0B" },
  fish: { name: "Peixe", icon: "\uD83D\uDC1F", color: "#2563EB" },
  peanuts: { name: "Amendoim", icon: "\uD83E\uDD5C", color: "#92400E" },
  soy: { name: "Soja", icon: "\uD83E\uDED8", color: "#059669" },
  milk: { name: "Leite", icon: "\uD83E\uDD5B", color: "#7C3AED" },
  nuts: { name: "Frutos secos", icon: "\uD83C\uDF30", color: "#B45309" },
  celery: { name: "Aipo", icon: "\uD83C\uDF3F", color: "#16A34A" },
  mustard: { name: "Mostarda", icon: "\uD83D\uDFE1", color: "#CA8A04" },
  sesame: { name: "Sesamo", icon: "\u26AA", color: "#6B7280" },
  sulphites: { name: "Sulfitos", icon: "\uD83C\uDF77", color: "#7C2D12" },
  lupin: { name: "Tremoco", icon: "\uD83C\uDF38", color: "#DB2777" },
  molluscs: { name: "Moluscos", icon: "\uD83D\uDC1A", color: "#0891B2" },
};
